import { DeliveryAddress } from '~/src/common/typings/cart';
import { Location } from '~/src/typings/addresses/types';

import { isServerSide } from './server';

let Geocoder: google.maps.Geocoder | null = null;

type GeocodeRequestPayload =
  | {
      placeId: string;
    }
  | {
      address: string;
    }
  | {
      location: Location;
    };

export const geocode = (request: GeocodeRequestPayload) => {
  if (!isServerSide() && Geocoder == null && window.google != null) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access  -- auto-ignored when updating eslint
    Geocoder = new window.google.maps.Geocoder();
  }

  return new Promise<google.maps.GeocoderResult[] | null>((resolve, reject) => {
    if (Geocoder == null) {
      reject(new Error('Geocoder is not defined'));

      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-floating-promises  -- auto-ignored when updating eslint
    Geocoder.geocode(
      request,
      (results: google.maps.GeocoderResult[] | null, status: google.maps.GeocoderStatus) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access  -- auto-ignored when updating eslint
        if (status !== window.google.maps.GeocoderStatus.OK) {
          reject(new Error(status));
        }

        resolve(results);
      },
    );
  });
};

export const mapGeocoderResultToDeliveryAddress = (
  result: google.maps.GeocoderResult,
): DeliveryAddress => ({
  addressComponents: {
    streetNumber:
      result.address_components.find(({ types }) => types[0] === 'street_number')?.long_name ?? '',
    street: result.address_components.find(({ types }) => types[0] === 'route')?.long_name ?? '',
    city:
      result.address_components.find(({ types }) => types[0] === 'locality')?.long_name ??
      result.postcode_localities?.[0] ??
      '',
    postalCode:
      result.address_components.find(({ types }) => types[0] === 'postal_code')?.long_name ?? '',
    country: result.address_components.find(({ types }) => types[0] === 'country')?.long_name ?? '',
    countryCode:
      result.address_components.find(({ types }) => types[0] === 'country')?.short_name ?? '',
  },
  formattedAddress: result.formatted_address,
  location: {
    lat: result.geometry.location.lat(),
    lng: result.geometry.location.lng(),
  },
});

/**
 * Get ne, se, sw, nw bounds of the given locations
 * @param locations Location[]
 */
export const getMapBounds = (locations: Location[]) => {
  const bounds = new google.maps.LatLngBounds();

  locations.forEach(location => {
    bounds.extend(new google.maps.LatLng(location.lat, location.lng));
  });

  const neBounds = bounds.getNorthEast();
  const swBounds = bounds.getSouthWest();
  const ne = { lat: neBounds.lat(), lng: neBounds.lng() };
  const sw = { lat: swBounds.lat(), lng: swBounds.lng() };
  const nw = { lat: ne.lat, lng: sw.lng };
  const se = { lat: sw.lat, lng: ne.lng };

  return { ne, se, sw, nw };
};
